/* eslint-disable camelcase */
import React, { Component } from 'react';
import { Icon, Select, Input, Tabs, Collapse, Tooltip } from '@tinper/next-ui';
import '../style/filterModal.less';
import { parseCStyle } from '../../../utils';
import { v4 as uuid } from 'uuid'

const TabPane = Tabs.TabPane;
const Panel = Collapse.Panel;

export default class LeftFilterModal extends Component {
  constructor (props) {
    super(props);
    this.state = {
      querySearchValue: '', // 搜索候选条件
      mouseEnterId: '',
      activeKey: 'common',
      selectedId: this.props.currentId // 选择的方案id
    };
    this.schemeValue = 'web';
  }

  componentDidMount () {
  }

  handleBodyClick = (e) => {
    if (e.target.className === 'query-item-button add-query-criteria') {
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    }
    document.body.removeEventListener('click', this.handleBodyClick);
  }

  chooseScheme (element) {
    this.setState({ selectedId: element.solutionId });
    this.props.editSchemeInfo(element)
  }

  changeSchemeList = (value) => {
    this.schemeValue = value
    this.IsEnterSchemeitem()
  }

  IsEnterSchemeitem = (id) => {
    const { schemeList = [] } = this.props;
    for (let i = 0; i < schemeList.length; i++) {
      if (id === schemeList[i].solutionId) {
        this.setState({ mouseEnterId: id });
        return;
      } else {
        this.setState({ mouseEnterId: '' });
      }
    }
  }

  // 渲染候选条件列表
  renderConditionsContent () {
    const { conditionsList, ValueList } = this.props; // 候选条件列表, 方案元数据列表
    const { querySearchValue = '' } = this.state; // 搜索关键词
    const contents = []; // 渲染的内容
    conditionsList.forEach((ele, index) => {
      const showItem = ele.caption?.indexOf(querySearchValue) !== -1
      const checkedValue = ValueList.map(i => i.storeField); // 已选候选条件值
      const checkedFlag = checkedValue?.includes(ele.storeField)
      const checkedStyle = checkedFlag ? { color: '#999', cursor: 'not-allowed' } : {}
      const common = (
        <div
          className='new-common'
          key={index}
          onClick={() => this.selectCondition(ele)}
          fieldid={`${this.props.fieldid}|${ele.storeField}`}
          style={checkedStyle}
        >
          {ele.caption}
          {/* 选完的条件不显示icon */}
          {checkedFlag ? null : <Icon type="uf-add-c-o" className='add-common-icon' />}
        </div>
      )
      showItem && contents.push(common)
    });
    let filterAdd = null
    const userdef_filterItem = this.props.User?.userdef_filterItem;
    if (userdef_filterItem) {
      filterAdd = <div className='defined_button' onClick={this.props.openDefined}>
        {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8011A', '自定义过滤条件', undefined, { returnDom: true, placement: 'top' })}
        <Tooltip placement='top' overlay={<span>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8011C', '若预置方案中没有您想要的条件，可以自定义过滤条件', undefined, { returnDom: true, placement: 'top' })}</span>} overlayClassName='definedCommonTip'>
          <Icon type="uf-a-wenhaomoren" className='definedCommonHelper' />
        </Tooltip>
      </div>
    }
    return <div className="queryCriteriaSelect">
      <Input
        fieldid={`${this.props.fieldid}|queryList_search`}
        value={querySearchValue}
        placeholder={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8010C', '请输入关键字', undefined, { returnDom: true, placement: 'top' })}
        onChange={(value) => { this.setState({ querySearchValue: value }) }}
      />
      <div className='commons-group'>
        {contents.length ? contents : <div>{querySearchValue ? lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8010F', '搜索无结果', undefined, { returnDom: true, placement: 'top' }) : lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80110', '暂时没有数据哦~', undefined, { returnDom: true, placement: 'top' })}</div>}
      </div>
      {/* {filterAdd} */}
    </div>
  }

  // 点击选择候选条件
  selectCondition (val) {
    const { ValueList } = this.props;
    const checkedIdList = ValueList.map(i => i.storeField); // 已选值id集合
    if (checkedIdList.includes(val.storeField)) return; // 如果已选
    // 设置选中的条件
    val.renderAlias = `queryschemeitem_${uuid().slice(0, 6)}`;
    val.visible = true;
    this.props.setSolutionMetaList([...ValueList, val])
    this.setState({ querySearchValue: '' });
  }

  // 渲染查询方案列表
  renderSchemeContent () {
    const { schemeList, User } = this.props;
    const userdef_schemaSetting = User && User.userdef_schemaSetting
    const webPlan = [];
    const mobilePlan = [];
    const webPlanPersonal = [];
    const mobilePlanPersonal = [];
    if (schemeList?.length > 0) {
      schemeList.forEach((element, index) => {
        const showDele = !element.isDefault;
        // 扩展字段配置方案不可删除
        const prohibitDeletion = element.cExtProps && parseCStyle(element.cExtProps)?.prohibitDeletion || element.caption === lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8010E', '系统方案', undefined, { returnDom: true, placement: 'top' });
        const isChecked = element.solutionId == this.state.selectedId;
        const itemChecked = isChecked ? <span className='groupCondition-Checked'><i className='yonicon yonicon-xuanzhong1' checked={isChecked} /></span> : <span className='groupCondition-Checked' />;
        const isDefault = element.isDefault ? element.isDefault : false;
        const isMouseEnter = element.solutionId === this.state.mouseEnterId;

        if (element.isPublic) {
          const itemDefault = isDefault ? <span className='groupCondition-Default'><span className='crossdefaultBtn'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80111', '默认', undefined, { returnDom: true, placement: 'top' })}</span></span> : <span className='groupCondition-Default' />;
          const deleteEle = prohibitDeletion
            ? <span />
            : userdef_schemaSetting
              ? <span className='Noclose' onClick={(event) => { event.stopPropagation(); this.props.deleteScheme(element.solutionId) }} style={{ display: showDele == true ? 'inline' : 'none' }}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80112', '删除', undefined, { returnDom: true, placement: 'top' })}</span>
              : <span />
          const itemChoose = <span style={{ cursor: 'pointer' }} className={isChecked ? 'scheme-name-checked scheme-name' : 'scheme-name'}> {element.caption ? element.caption : element.solutionId}</span>
          const itemEnter = isMouseEnter
            ? <span className='groupCondition-MouseEnter'>
              {deleteEle}
            </span>
            : <span className='groupCondition-MouseEnter' />;
          const rowCheckedStyle = isChecked ? { backgroundColor: 'var(--wui-base-item-bg-selected)' } : null
          const item = (
            <div
              className='yonRow yon-row'
              key={index}
              style={rowCheckedStyle}
              onMouseLeave={() => this.IsEnterSchemeitem()}
              onMouseEnter={() => this.IsEnterSchemeitem(element.solutionId, element.mobileFilte)}
              onClick={() => this.chooseScheme(element)}
            >
              {itemChoose}
              {itemDefault}
              {itemChecked}
              {itemEnter}
            </div>
          )
          if (element.mobileFilte) {
            mobilePlan.push(item);
          } else {
            webPlan.push(item);
          }
        } else {
          const itemDefault = isDefault ? <span className='groupCondition-Default'><span className='crossdefaultBtn-personal'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80111', '默认', undefined, { returnDom: true, placement: 'top' })}</span></span> : <span className='groupCondition-Default' />;
          const deleteEle = <span className='Noclose' onClick={(event) => { event.stopPropagation(); this.props.deleteScheme(element.solutionId) }} style={{ display: showDele == true ? 'inline' : 'none' }}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80112', '删除', undefined, { returnDom: true, placement: 'top' })}</span>;
          const itemChoose = <span className={isChecked ? 'scheme-name-checked scheme-name' : 'scheme-name'} style={{ cursor: 'pointer' }}>{element.caption ? element.caption : element.solutionId}</span>
          const itemEnter = isMouseEnter
            ? <span className='groupCondition-MouseEnter'>
              { isDefault
                ? null
                : <span className='stopclose' onClick={(e) => this.props.setDefaultScheme(element.solutionId, e, false, element.mobileFilte)}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80113', '设为默认', undefined, { returnDom: true, placement: 'top' })}</span>
              }
              {deleteEle}
            </span>
            : <span className='groupCondition-MouseEnter' />;
          const rowCheckedStyle = isChecked ? { backgroundColor: 'var(--wui-base-item-bg-selected)' } : null
          const perItem = (
            <div
              className='yonRow yon-row'
              key={index}
              style={rowCheckedStyle}
              onMouseLeave={() => this.IsEnterSchemeitem()}
              onMouseEnter={() => this.IsEnterSchemeitem(element.solutionId, element.mobileFilte)}
              onClick={() => this.chooseScheme(element)}
            >
              {itemChoose}
              {itemDefault}
              {itemChecked}
              {itemEnter}
            </div>
          )
          if (element.mobileFilte) {
            mobilePlanPersonal.push(perItem);
          } else {
            webPlanPersonal.push(perItem);
          }
        }
      }, this)
    }
    const Option = Select.Option
    return (
      <div>
        <div className='scheme-selector'>
          <Select defaultValue='web' onChange={(e) => this.changeSchemeList(e)}>
            <Option value='web'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80114', 'Web方案', undefined, { returnDom: true, placement: 'top' })}</Option>
            {/* <Option value='mobile'>移动方案</Option> */}
          </Select>
        </div>
        { this.schemeValue === 'web'
          ? <Collapse className='mdf-collapse-head' bodyClassName='mdf-collapse' defaultActiveKey={['personal', 'public']} ghost={true}>
            <Panel header={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80116', '公共方案', undefined, { returnDom: true, placement: 'top' })} key='public' showArrow={true}>{webPlan?.length > 0 ? webPlan : <span className='no-scheme'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80115', '暂无公共方案', undefined, { returnDom: true, placement: 'top' })}</span>}</Panel>
            <Panel header={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80118', '个人方案', undefined, { returnDom: true, placement: 'top' })} key='personal' showArrow={true}>{webPlanPersonal?.length > 0 ? webPlanPersonal : <span className='no-scheme'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80117', '暂无个人方案', undefined, { returnDom: true, placement: 'top' })}</span>}</Panel>
          </Collapse>
          : <Collapse className='mdf-collapse-head' bodyClassName='mdf-collapse' defaultActiveKey={['personal', 'public']} ghost={true}>
            <Panel header={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80116', '公共方案', undefined, { returnDom: true, placement: 'top' })} key='public' showArrow={true}>{mobilePlan?.length > 0 ? mobilePlan : <span className='no-scheme'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80115', '暂无公共方案', undefined, { returnDom: true, placement: 'top' })}</span>}</Panel>
            <Panel header={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80118', '个人方案', undefined, { returnDom: true, placement: 'top' })} key='personal' showArrow={true}>{mobilePlanPersonal?.length > 0 ? mobilePlanPersonal : <span className='no-scheme'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80117', '暂无个人方案', undefined, { returnDom: true, placement: 'top' })}</span>}</Panel>
          </Collapse>
        }
        <div className='add-scheme group-grouping'>
          <div className='add-scheme-button' onClick={this.AddNewScheme}>
            {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8010D', '新增方案', undefined, { returnDom: true, placement: 'top' })}
          </div>
        </div>
      </div>
    )
  }

  // 新增方案
  AddNewScheme = () => {
    this.props.AddScheme()
    this.setState({ querySearchValue: '', activeKey: 'common' });
  }

  render () {
    const { isEdit } = this.props;
    return (
      <Tabs
        className='leftTabs'
        type='line'
        activeKey={this.state.activeKey}
        onChange={key => { this.setState({ activeKey: key }) }}
      >
        <TabPane tab={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80119', '候选条件', undefined, { returnDom: true, placement: 'top' })} key='common' className='mdf-tab-content' fieldid={`${this.props.fieldid}|common`}>{this.renderConditionsContent()}</TabPane>
        {isEdit && this.props.hasQueryScheme ? <TabPane tab={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8011B', '查询方案', undefined, { returnDom: true, placement: 'top' })} key='scheme' className='mdf-tab-content' fieldid={`${this.props.fieldid}|scheme`}>{this.renderSchemeContent()}</TabPane> : null}
      </Tabs>
    )
  }
}
